import { Entity } from '../../../../base/Entity'

import { type Role } from '../../../../Foobara/Auth/Types/Role/Ambiguous'

import { type Domain } from '../../../../Foobara/Commandforge/Types/Domain/Ambiguous'

import { type Organization } from '../../../../Foobara/Commandforge/Types/Organization/Ambiguous'

export type UserPrimaryKeyType = number
export const userPrimaryKeyAttributeName: 'id' = 'id'
export interface UserAttributesType {
  id: number
  owned_organizations: Organization[]
  member_of_organizations: Organization[]
  owned_domains: Domain[]
  member_of_domains: Domain[]
  username?: string
  email?: string | null
  roles?: Role[]
}

export class User<
  AttributesType extends UserAttributesType = UserAttributesType
> extends Entity<UserPrimaryKeyType, AttributesType> {
  static readonly modelName: string = 'User'
  static readonly entityName: string = 'User'
  static readonly primaryKeyAttributeName: 'id' = 'id'

  get id (): UserPrimaryKeyType {
    return this.primaryKey
  }

  get associationPropertyPaths (): string[][] { return [['member_of_domains', '#', 'persisted_types', '#'], ['owned_domains', '#', 'persisted_types', '#'], ['roles', '#']] }
  readonly hasAssociations: true = true

  get owned_organizations (): AttributesType['owned_organizations'] {
    return this.readAttribute('owned_organizations')
  }

  get member_of_organizations (): AttributesType['member_of_organizations'] {
    return this.readAttribute('member_of_organizations')
  }

  get owned_domains (): AttributesType['owned_domains'] {
    return this.readAttribute('owned_domains')
  }

  get member_of_domains (): AttributesType['member_of_domains'] {
    return this.readAttribute('member_of_domains')
  }

  get username (): AttributesType['username'] {
    return this.readAttribute('username')
  }

  get email (): AttributesType['email'] {
    return this.readAttribute('email')
  }

  get roles (): AttributesType['roles'] {
    return this.readAttribute('roles')
  }
}
